import HomeHeader from "modules/home-header"

interface Props {
  account: string
}

export default function EzeHeader({ account }: Props) {
  return <HomeHeader account={account} title="Eze Application" />
}
